export default function useProductIDs() {
  const allIDs = "5056,7622";
  const chipIDs = "5056,7622";

  return { allIDs, chipIDs };
}
